enum TextTrackKindEnum {
	subtitles = 'subtitles',
	captions = 'captions',
	descriptions = 'descriptions',
	chapters = 'chapters',
	metadata = 'metadata'
}

export default TextTrackKindEnum;
